import { action } from "typesafe-actions";
import {
  IMarketingCampain,
  IWhatsAppTemplateData,
  IWhatsAppTemplateList,
  IWhatsAppTemplatePayload,
} from "./marketCampaign.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_PROGRESS =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_PROGRESS";
export const FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_SUCCESS =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_SUCCESS";
export const FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_FAILED =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_FAILED";

export const fetchMarketingWhatsAppTemplatesListProgress = () =>
  action(FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_PROGRESS);
export const fetchMarketingWhatsAppTemplatesListSuccess = (
  list: IWhatsAppTemplateList[]
) => action(FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_SUCCESS, { list });
export const fetchMarketingWhatsAppTemplatesListFailed = () =>
  action(FETCH_MARKETING_WHATSAPP_TEMPLATE_LIST_FAILED);

export const fetchMarketingWhatsAppTemplatesListAsync =
  (status: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        // const searchQuery = getSearchQuery(queryParams);
        dispatch(fetchMarketingWhatsAppTemplatesListProgress());

        let url = "";
        if (status !== "-1") {
          url += `&status=${status}`;
        }
        let finalUrl = `/template/get-whatsapp-exotel-template?` + url;
        const res = await api.get(finalUrl);
        const data: IWhatsAppTemplateList[] = res.data.data;

        dispatch(fetchMarketingWhatsAppTemplatesListSuccess(data));
      } catch (err: any) {
        dispatch(fetchMarketingWhatsAppTemplatesListFailed());
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const FETCH_MARKETING_WHATSAPP_TEMPLATE_PROGRESS =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_PROGRESS";
export const FETCH_MARKETING_WHATSAPP_TEMPLATE_SUCCESS =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_SUCCESS";
export const FETCH_MARKETING_WHATSAPP_TEMPLATE_FAILED =
  "FETCH_MARKETING_WHATSAPP_TEMPLATE_FAILED";

export const fetchMarketingWhatsAppTemplateProgress = () =>
  action(FETCH_MARKETING_WHATSAPP_TEMPLATE_PROGRESS);
export const fetchMarketingWhatsAppTemplateSuccess = (
  data: IWhatsAppTemplateData
) => action(FETCH_MARKETING_WHATSAPP_TEMPLATE_SUCCESS, { data });
export const fetchMarketingWhatsAppTemplateFailed = (errorMessage: string) =>
  action(FETCH_MARKETING_WHATSAPP_TEMPLATE_FAILED, { errorMessage });

export const fetchMarketingWhatsAppTemplateAsync =
  (templateName: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchMarketingWhatsAppTemplateProgress());

        const res = await api.get(
          `/template/get-whatsapp-exotel-template?template_name=${templateName}`
        );
        const data = res.data.data;
        if (data.length > 0) {
          const finalData: IWhatsAppTemplateData = data[0];
          const result: any = {
            components: [],
            header: {
              type: "HEADER",
              text: "",
            },
            body: {
              type: "BODY",
              text: "",
            },
            buttons: {
              type: "BUTTONS",
              buttons: [],
            },
            footer: {
              type: "FOOTER",
              text: "",
            },
          };

          for (const data of finalData.components) {
            if (data.type === "HEADER") {
              result.header.text = data.text;
            } else if (data.type === "BODY") {
              result.body.text = data.text;
            } else if (data.type === "BUTTONS") {
              result.buttons.buttons = data.buttons as any;
            } else if (data.type === "FOOTER") {
              result.footer.text = data.text;
            }
          }
          finalData.header = result.header;
          finalData.body = result.body;
          finalData.footer = result.footer;
          finalData.buttons = result.buttons;
          dispatch(fetchMarketingWhatsAppTemplateSuccess(finalData));
        } else {
          dispatch(
            fetchMarketingWhatsAppTemplateFailed(
              "Unfortunately, there are no records available at the moment."
            )
          );
        }
      } catch (err: any) {
        dispatch(
          fetchMarketingWhatsAppTemplateFailed("Something went to be wrong!")
        );
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };


export const upsertMarketingWhatsApp =
  (
    data: IWhatsAppTemplateData,

    onCallBack: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        const finalData: IWhatsAppTemplatePayload = {
          name: data.name,
          category: data.category,
          components: [data.body],
          language: data.language,
          waba_id: data.waba_id,
        };
        if (data.header.text.length > 0) {
          finalData.components.push(data.header);
        }
        if (data.footer.text.length > 0) {
          finalData.components.push(data.footer);
        }
        if (data.buttons.buttons.length > 0) {
          finalData.components.push(data.buttons);
        }
        await api.post("/template/create-whatsapp-template", finalData);
        dispatch(
          showMessage({
            type: "success",
            message: "Market campaign is saved successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack(true);
      } catch (err: any) {
        onCallBack(false);

        dispatch(
          showMessage({
            type: "error",
            message: JSON.stringify(err.response.data),
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const FETCH_MARKETING_CAMPAIGN_LIST_PROGRESS =
  "FETCH_MARKETING_CAMPAIGN_LIST_PROGRESS";
export const FETCH_MARKETING_CAMPAIGN_LIST_SUCCESS =
  "FETCH_MARKETING_CAMPAIGN_LIST_SUCCESS";
export const FETCH_MARKETING_CAMPAIGN_LIST_FAILED =
  "FETCH_MARKETING_CAMPAIGN_LIST_FAILED";

export const fetchMarketingCampaignListProgress = () =>
  action(FETCH_MARKETING_CAMPAIGN_LIST_PROGRESS);
export const fetchMarketingCampaignListSuccess = (list: IMarketingCampain[]) =>
  action(FETCH_MARKETING_CAMPAIGN_LIST_SUCCESS, { list });
export const fetchMarketingCampaignListFailed = () =>
  action(FETCH_MARKETING_CAMPAIGN_LIST_FAILED);

export const fetchMarketingCampaignListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        // const searchQuery = getSearchQuery(queryParams);
        dispatch(fetchMarketingCampaignListProgress());

        let url = "";
        if (status !== "-1") {
          url += `&status=${status}`;
        }
        if (searchValue.length > 0) {
          url += `&advanceFilter=${JSON.stringify(searchValue)}`;
        }

        let finalUrl =
          `/campaign/get-campaigns?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
          url;
        const res = await api.get(finalUrl);
        const data: IMarketingCampain[] = res.data.data;

        dispatch(fetchMarketingCampaignListSuccess(data));
      } catch (err: any) {
        dispatch(fetchMarketingCampaignListFailed());
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const FETCH_MARKET_CAMPAIGN_PROGRESS = "FETCH_MARKET_CAMPAIGN_PROGRESS";
export const FETCH_MARKET_CAMPAIGN_SUCCESS = "FETCH_MARKET_CAMPAIGN_SUCCESS";
export const FETCH_MARKET_CAMPAIGN_FAILED = "FETCH_MARKET_CAMPAIGN_FAILED";

export const fetchMarketCampaignProgress = () =>
  action(FETCH_MARKET_CAMPAIGN_PROGRESS);
export const fetchMarketCampaignSuccess = (lead: IMarketingCampain) =>
  action(FETCH_MARKET_CAMPAIGN_SUCCESS, { lead });
export const fetchMarketCampaignFailed = (errorMessage: string) =>
  action(FETCH_MARKET_CAMPAIGN_FAILED, { errorMessage });

export const fetchMarketCampaignAsync =
  (marketCampainId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchMarketCampaignProgress());
        dispatch(saveLoaderProgress());
        const res = await api.get(
          `/campaign/get-campaigns?market_campaign_uuid=${marketCampainId}`
        );
        const data = res.data.data;
        if (data.length > 0) {
          dispatch(fetchMarketCampaignSuccess(data[0]));
        } else {
          dispatch(
            fetchMarketCampaignFailed(
              "Unfortunately, there are no records available at the moment."
            )
          );
        }
      } catch (err: any) {
        dispatch(fetchMarketCampaignFailed("Something went to be wrong!"));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const upsertMarketCampainAsync =
  (
    data: IMarketingCampain,
    onCallBack: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        const {
          create_ts,
          insert_ts,
          modified_by_name,
          modified_by_uuid,
          created_by_name,
          created_by_uuid,
          ...rest
        } = data;

        await api.post("/campaign/upsert-campaign", rest);
        dispatch(
          showMessage({
            type: "success",
            message: "Market campaign is saved successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack(true);
      } catch (err: any) {
        onCallBack(false);

        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const CLEAR_MARKET_CAMPAIGN_STATE = "CLEAR_MARKET_CAMPAIGN_STATE";
export const clearMerketCampaignState = () =>
  action(CLEAR_MARKET_CAMPAIGN_STATE);
